const ITEMS = ['Drive Beyond Ordinary', 'Miami Luxury Rentals', 'Airport Delivery', 'Concierge Service'];

const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/5 bg-[#0a0a0a] py-10 md:py-14" aria-hidden="true">
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((t, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className={`font-display whitespace-nowrap px-8 text-5xl md:text-7xl lg:text-8xl ${i % 2 === 0 ? 'outline-text' : 'outline-text-gold italic'}`}>
                  {t}
                </span>
                <span className="h-2 w-2 rotate-45 bg-gold/40" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
